import Request from './request'


async function fetchOne(id){
    return Request("get","api/suppliers/view?id=" + id)

}

async function save(id,data){
    return Request("patch","api/suppliers/edit?id=" + id,data)
}

export default {
    fetchOne,
    save
}